import { Store } from 'vuex'
import { emitter } from '@kwixeo/interface-vue'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.CalendarCreated',
    callback: (calendar: KwixeoCalendars.Calendar): void => {
      store.dispatch('calendars/addCalendar', calendar)
    }
  },
  {
    name: '.CalendarUpdated',
    callback: (calendar: KwixeoCalendars.Calendar): void => {
      store.dispatch('calendars/updateCalendar', calendar)
    }
  },
  {
    name: '.CalendarDeleted',
    callback: (calendar: KwixeoCalendars.Calendar): void => {
      store.dispatch('calendars/deleteCalendar', calendar)
    }
  },

  {
    name: '.EventCreated',
    callback: (event: KwixeoCalendars.Event): void => {
      emitter.emit('eventCreated', event)
    }
  },
  {
    name: '.EventUpdated',
    callback: (event: KwixeoCalendars.Event): void => {
      emitter.emit('eventUpdated', { old: null, new: event })
    }
  },
  {
    name: '.EventDeleted',
    callback: (event: KwixeoCalendars.Event): void => {
      emitter.emit('eventDeleted', event)
    }
  }
])
